<div class="space-y-2">
  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
    @if (label()) {
      <mat-label>{{ label() }}</mat-label>
    }
    <textarea
      matInput
      rows="5"
      aria-label="Votre texte de présentation"
      placeholder="Ex : Fort de 10 ans d'expérience dans l'immobilier résidentiel, j'accompagne mes clients vendeurs et acquéreurs avec rigueur, écoute et transparence..."
      [value]="bio() || ''"
      (input)="onChange($any($event.target).value)"
      maxlength="1000"
    ></textarea>
  </mat-form-field>
  <div class="flex justify-between items-center">
    @if (!isValid()) {
      <span class="text-[11px] text-error-11 font-medium">
        La biographie ne peut pas dépasser 1000 caractères.
      </span>
    } @else {
      <span></span>
    }
    <span
      class="text-[11px] font-mono transition-colors"
      [class.text-neutral-9]="isValid()"
      [class.text-error-11]="!isValid()"
    >
      {{ charCount() }} / 1000 caractères
    </span>
  </div>
</div>
